import React, {Fragment, useState} from 'react';
import {anularPago} from "../redux/reducers/pagosReducers"
import {FormControlLabel, Switch, IconButton, Table, TableBody, TableCell, TableHead, TableRow,TableContainer ,Typography,
  TableFooter,TablePagination,Theme, Box, Button} from '@mui/material';
import Strings from "../assets/strings";

import {AttachFile, Close} from "@mui/icons-material";
import {formatDate, formatPeso, hasPermissionTo, PERSMISOS} from '../helpers';

import {switchControl } from "../assets/jss";
import ConfirmDialog from "./ConfirmDialog";
import {useLocation, useNavigate} from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import ReciboPago from "./recibo";
import {useAppDispatch, useAppSelector} from "../redux/hooks";
import {IPago} from "../redux/types/IPago";
const useStyles = makeStyles((theme:Theme) => ({
  ...switchControl,
  barTitle:{
    // padding: "6px 12px",
    // background: theme.palette.grey[200],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& > label':{
      marginRight: 5
    }
  },
  pagAnulado:{
    background: "#fff1f1",
    "& td, th":{
      color:theme.palette.error.light,
    }
  },
  print: {
    color: theme.palette.primary.main,
  },
  row:{
    "&.tipo4":{
      background:"#d6f4ff !important"
    },
    "&.tipo8":{
      background:"#f8eaca !important"
    },
  },
  concepto:{
    "& svg":{
      fontSize: 14,
      marginLeft: -4,
      marginBottom: -1,
      color:theme.palette.secondary.main
    }
  }
}));


export default function Pagos({pagos=[],onClickPendiente, showSeguro,onTabClick,notasCount }:{notasCount?:number,pagos:IPago[],showSeguro?:boolean,onClickPendiente:(v:any)=>void, onTabClick:(tab:number)=>void}){
  let navigate = useNavigate();
  let location = useLocation();
  const classes = useStyles();
  let dispatch = useAppDispatch();
  let status = useAppSelector(state => state.pagos.status);
  const [showAnulado, setShowAnulado] = useState(false);

  //----
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (e: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  //---
  const eliminarPago  = () =>{
    dispatch(anularPago(location.state.confirmDialog))
  };
  const pagosActive = pagos.filter(p=>!p.fechaAnulacion && p.tipo !== 4)


  const totalCapital = pagosActive.reduce((a, b) => +a + (b.capital ?? 0), 0);
  const totalInteres = pagosActive.reduce((a, b) => +a + (b.interes ?? 0), 0);
  const totalMora = pagosActive.reduce((a, b) => +a + (b.mora ?? 0), 0);
  const totalDescuento = pagosActive.reduce((a, b) => +a + (b.descuento ?? 0), 0);
  const totalComision = pagosActive.reduce((a, b) => +a + (b.comision ?? 0), 0);
  const totalSegura = pagosActive.reduce((a, b) => +a + (b.seguro ?? 0), 0);
  const totalOtros = pagosActive.reduce((a, b) => +a + (b.otros ?? 0), 0);

  const totalPago = pagosActive.reduce((a, b) => +a + (b.totalPago ?? 0), 0);


    return (
      <Fragment>
        <div className={classes.barTitle}>
          <Box display={"flex"}>
            <Button onClick={()=>onTabClick(1)} variant="text" sx={{textTransform: "capitalize",height: "30px",background:"#eeeeee !important"}}>{Strings.pagos}</Button>
            <Button onClick={()=>onTabClick(2)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.amortizacion}</Button>
            <Button onClick={()=>onTabClick(3)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.notas} ({notasCount ??0})</Button>

          </Box>

          <FormControlLabel className="d-print-none"
            control={
              <Switch
                //disableRipple
                  size={"small"}
                  color={"secondary"}
                checked={showAnulado}
                onChange={()=>setShowAnulado(!showAnulado)}
                value="checkedB"
              />
            }
            label={Strings.anulado}
          />
        </div >
        <TableContainer >
          <Table className={"hasOnclick"}>
            <TableHead>
              <TableRow>
                <TableCell className={"d-print-none"}/>
                <TableCell>{Strings.concepto}</TableCell>
                <TableCell>{Strings.fecha}</TableCell>
                <TableCell>{Strings.fechaVencimiento}</TableCell>
                <TableCell align={"right"}>{Strings.totalPagado}</TableCell>
                <TableCell align={"right"}>{Strings.capital}</TableCell>
                <TableCell align={"right"}>{Strings.interes}</TableCell>
                <TableCell align={"right"}>{Strings.mora}</TableCell>
                <TableCell align={"right"}>{Strings.descuento}</TableCell>
                <TableCell align={"right"}>{Strings.comision}</TableCell>
                {showSeguro &&  <TableCell align={"right"}>{Strings.seguro}</TableCell>}
                <TableCell align={"right"}>{Strings.otros}</TableCell>
                <TableCell align={"right"}>{Strings.capitalPendiente}</TableCell>
                <TableCell>{Strings.caja}</TableCell>
                <TableCell>{Strings.creadoPor}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pagos.filter(p=>!p.fechaAnulacion || Boolean(p.fechaAnulacion) === showAnulado ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n =>
                    <TableRow key={n.id} className={classes.row + (!!n.fechaAnulacion?" "+classes.pagAnulado:" tipo"+n.tipo)}
                              onClick={()=> {
                                if(n.tipo === 8) //pago tipo borrador
                                  onClickPendiente(n)
                                else
                                navigate(location.pathname, {state:{recibo: n}})
                              }}>
                      <TableCell className={"actionCell"}>
                        {hasPermissionTo(PERSMISOS.pagosEliminar) && n.anulable &&
                            <IconButton
                                onClick={(e)=>{
                                    e.stopPropagation();
                                    navigate(location.pathname,{state:{confirmDialog: {id: n.id, prestamoId: n.prestamoId}}})
                                  }
                                }
                                disabled={Boolean(n.fechaAnulacion)}
                                size="large">
                              <Close className={"text-red"}/>
                            </IconButton>
                        }
                      </TableCell>
                      <TableCell component="th" scope="row" className={classes.concepto}>{!!n.adjunto && <AttachFile />}  {n.concepto}</TableCell>
                      <TableCell>{formatDate(n.fecha)}</TableCell>
                      <TableCell>{formatDate(n.fechaVencimiento)}</TableCell>
                      <TableCell align={"right"} sx={{background: "#ebebeb",fontWeight: "bold"}}>{formatPeso(n.totalPago)}</TableCell>
                      {n.tipo === 4 || n.tipo === 8?(
                          <>
                              <TableCell colSpan={showSeguro ? 7 : 6}/>
                          </>
                      ):(
                          <>
                            <TableCell align={"right"}>{formatPeso(n.capital)}</TableCell>
                            <TableCell align={"right"}>{formatPeso(n.interes)}</TableCell>
                            <TableCell align={"right"}>{formatPeso(n.mora)}</TableCell>
                            <TableCell align={"right"}>{formatPeso(n.descuento)}</TableCell>
                            <TableCell align={"right"}>{formatPeso(n.comision)}</TableCell>
                            {showSeguro && <TableCell align={"right"}>{formatPeso(n.seguro)}</TableCell>}
                            <TableCell align={"right"}>{formatPeso(n.otros)}</TableCell>

                          </>
                      )}
                      <TableCell align={"right"}>{formatPeso(n.nuevoCapital)}</TableCell>
                      <TableCell>{n.caja} </TableCell>
                      <TableCell>{n.usuarioCreadoPor}</TableCell>
                    </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow className={""}>

                <TableCell colSpan={4}><Typography align={"right"}>{Strings.total}:</Typography></TableCell>
                <TableCell align={"right"}>{formatPeso(totalPago)}</TableCell>
                <TableCell align={"right"}>{formatPeso(totalCapital)}</TableCell>
                <TableCell align={"right"}>{formatPeso(totalInteres)}</TableCell>
                <TableCell align={"right"}>{formatPeso(totalMora)}</TableCell>
                <TableCell align={"right"}>{formatPeso(totalDescuento)}</TableCell>
                <TableCell align={"right"}>{formatPeso(totalComision)}</TableCell>
                {showSeguro && <TableCell align={"right"}>{formatPeso(totalSegura)}</TableCell>}
                <TableCell align={"right"}>{formatPeso(totalOtros)}</TableCell>

                <TableCell colSpan={3}/>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer >
        {pagos.length > 10 &&
          <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={pagos.length - (!showAnulado ? pagos.filter(p=>!!p.fechaAnulacion).length:0)}
              rowsPerPage={rowsPerPage}
              SelectProps={{
                inputProps: {'aria-label': 'No. registros'},
                native: true,
              }}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
        <ConfirmDialog onConfirm={eliminarPago}/>
        <ReciboPago />

      </Fragment>
    );

}

